export default "<div class=\"graphs\">\r\n    <canvas #canvas></canvas>\r\n</div>\r\n";